import React from 'react';
import { Form, FormGroup, Alert, Modal, Button, Schema } from 'rsuite';
import { Field } from '../../helpers/rsuite/Form';
import USER_STATUSES from '../../constants/users/statuses';
import { loginService, usersService } from '../../services';
import Password from '../../constants/logins/password';

const size = {
    lg: 'lg', // large
    md: 'md', // medium
    sm: 'sm', // small
    xs: 'xs' // extra small
};

const defaultFormPassword = {
    password: '',
};

const passwordRegex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[[\]/#=?!@$%^&{}()|*+.:,;`'~_-]).{8,}$/;
const required = 'Este campo es requerido.';
const { StringType } = Schema.Types;
const model = Schema.Model({
    password: StringType().isRequired(required)
        .minLength(8, 'Mínimo 8 caracteres.')
        .maxLength(20, 'Máximo 20 caracteres.')
        .pattern(passwordRegex, 'Debe tener mínimo un número, una letra mayúscula y un caracter especial.'),
});

export default function ResetPasswordSellerDialog ({ show, onHide, idSeller }) {
    const formRef = React.useRef();

    const [isLoading, setIsLoading] = React.useState(false);

    // eslint-disable-next-line no-unused-vars
    const [formErrorPassword, setFormErrorPassword] = React.useState({});
    const [formPassword, setFormPassword] = React.useState(defaultFormPassword);

    const save = () => {
        setIsLoading(true);
        if (!formRef.current.check()) {
            console.error('Form Error');
            return;
        }

        const body = {
            idUser: idSeller,
            idPlatform: 8,
            password: formPassword.password.trim(),
        };

        return loginService
            .resetPasswordSeller(body)
            .then(response => updateUser(idSeller))
            .then(() => Alert.success('La contraseña fue modificada correctamente.', 5000))
            .then(() => onHide())
            .catch(e => {
                console.error(e);
                const dataError = e?.response?.data;

                // Password invalid
                if (dataError?.extra?.key === Password.invalid) {
                    if (dataError?.extra?.invalidations?.length) {
                        // "invalidations": [ "spaces", "symbols", "digits", ...],
                        const reason = dataError.extra.invalidations.join(',');
                        return Alert.error(`La contraseña es invalida. Razón: ${reason}`, 8000);
                    }
                    return Alert.error('La contraseña es invalida.', 5000);
                }
                // Password already used
                if (dataError?.extra?.key === Password.alreadyUsed) {
                    return Alert.error('La contraseña ya ha sido usada anteriormente.', 5000);
                }

                return Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
            })
            .finally(() => setIsLoading(false));
    };

    const updateUser = (id) => {
        const data = {
            idStatus: USER_STATUSES.recovery.id,
            reason: 'Password reset',
        };
        return usersService.toggle(id, data);
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='reset-password-seller-modal'
            size={size.sm}
            keyboard={false}
        >
            <Modal.Header closeButton >
                <Modal.Title id='reset-password-seller-modal'>
                    <div className='d-flex justify-content-around'>
                        <span>Reset Password # {idSeller}</span>
                    </div>
                </Modal.Title>
            </Modal.Header >
            <Modal.Body className='h-75' style={{ overFlow: 'hidden! important' }}>
                {!isLoading && (
                    <div className='row justify-content-center'>
                        <div className='col-md-10'>
                            <Form
                                fluid
                                ref={formRef}
                                formValue={formPassword}
                                onChange={setFormPassword}
                                onCheck={setFormErrorPassword}
                                model={model}
                            >
                                <h3>Ingrese una nueva password para el vendedor</h3>
                                <br/>
                                <div className="container">
                                    <Field classNameGroup='mb-3' classNameLabel='font-weight-bold' label="Password" name="password" />
                                </div>
                                <FormGroup />
                            </Form>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div className='d-flex justify-content-around'>
                    <div>
                        <Button appearance='primary' loading={isLoading} disabled={isLoading} onClick={save} >Guardar</Button>
                        <Button disabled={isLoading} onClick={onHide} >Cancelar</Button>
                    </div>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
